import React, {useEffect} from 'react';
import "aos/dist/aos.css";
import AOS from "aos";
import '../style/constructioncleaning.css';
import "../style/officecleaning.css";
import { Typography } from "@mui/material";
import { FaRegCheckCircle } from "react-icons/fa";
import { LazyLoadImage } from "react-lazy-load-image-component";
import imgServ1 from "../images/photo-glass1.png";
import imgServ2 from "../images/photo-glass2.png";
import imgServ3 from "../images/photo-glass3.png";
import imgServ4 from "../images/photo-glass4.png";
import Infokontakt from "../components/Infokontakt";
import Footer from "../components/Footer";

function Constructioncleaning() {
    useEffect(() => {
        AOS.init();
        window.scrollTo(0, 0);
      }, []);
    
      return (
        <div className="continer-office-cleaning">
          <div className="cover-img-content-construction">
            <div className="photocontent-box">
              <Typography
                variant="h3"
                sx={{
                  color: "var(--mainColor)",
                  fontFamily: "var(--fontFamily)",
                  fontWeight: "medium",
                }}
              >
                Bauabschlussreinigung
              </Typography>
            </div>
          </div>
          <div className="content-text-for-services">
            <div className="text-service-first">
              <Typography
                variant="h5"
                gutterBottom
                sx={{
                  color: "var(--mainColorLight)",
                  fontFamily: 'var(--fontFamily)',
        fontWeight: '700',
                }}
              >
                Bauendreinigung für eine perfekte Übergabe
              </Typography>
            </div>
            <div
              className="text-body-service"
              data-aos="zoom-out"
              data-aos-anchor-placement="top-bottom"
              data-aos-offset="100"
              data-aos-duration="1000"
              data-aos-once="true"
            >
              <Typography
                gutterBottom
                variant="body2"
                sx={{
                  fontWeight: "normal",
                  fontFamily: 'var(--fontFamily)',
                   color:'var(--textColor)'
                }}
              >
                Nach Neubau, Umbau oder Renovierung sorgen wir für den letzten Schliff. Unsere professionelle Bauendreinigung hinterlässt Ihre Immobilie sauber, staubfrei und bezugsfertig – für einen überzeugenden ersten Eindruck.<br/>
                <br /> Unsere erfahrenen Reinigungsteams entfernen zuverlässig Baustaub, Schmutz, Schutzfolien und Baurückstände. Mit modernen Reinigungsmethoden und hochwertigen, umweltfreundlichen Reinigungsmitteln reinigen wir Böden, Oberflächen, Glasflächen und Sanitärbereiche gründlich und materialschonend.<br/>
                <br />Ob Wohnhaus, Bürogebäude oder Gewerbeobjekt – wir passen unsere Leistungen flexibel an Ihr Projekt an und sorgen für eine reibungslose Übergabe<br/>
              
              </Typography>
            </div>
            <div className="textandphoto-service">
              <div
                className="text-service-line"
                data-aos="fade-right"
                data-aos-offset="50"
                data-aos-duration="1000"
              >
                <h4>Ihre Vorteile auf einen Blick</h4>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: 'var(--fontFamily)',
                    color:'var(--textColor)'
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                  Professionelle Bauendreinigung für alle Objektarten
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: 'var(--fontFamily)',
                    color:'var(--textColor)'
                  }}
               
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
               Gründliche Entfernung von Baustaub und Baurückständen
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: 'var(--fontFamily)',
                   color:'var(--textColor)'
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                  Streifenfreie und bezugsfertige Ergebnisse
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: 'var(--fontFamily)',
                    color:'var(--textColor)'
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                 Pünktlicher & zuverlässiger Service
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: 'var(--fontFamily)',
                    color:'var(--textColor)'
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                Transparente Preise & Top-Bewertungen
                </Typography>
               
              </div>
              <div className="photo-service-line">
                <div
                  className="photo1-service"
                  data-aos="flip-left"
                  data-aos-offset="50"
                  data-aos-duration="1000"
                >
                  <LazyLoadImage
                    src={imgServ1}
                    style={{
                      width: "100%",
                      borderRadius: "10px",
                      boxShadow: " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    }}
                  />
                </div>
                <div
                  className="photo2-service"
                  data-aos="flip-right"
                  data-aos-offset="50"
                  data-aos-duration="1000"
                >
                  <LazyLoadImage
                    src={imgServ2}
                    style={{
                      width: "100%",
                      borderRadius: "10px",
                      boxShadow: " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="content-text-for-services2">
            <div className="text-service-first">
              <Typography
                variant="h5"
                gutterBottom
                sx={{
                  color: "var(--mainColorLight)",
                  fontFamily: 'var(--fontFamily)',
                  fontWeight: '700',
                }}
              >
                Entdecken Sie die Vorteile unserer Bauabschlussreinigung!
              </Typography>
            </div>
            <div className="text-body-service2">
              <div
                className="text-for-service-body"
                data-aos="fade-right"
                data-aos-anchor-placement="top-bottom"
                data-aos-offest="200"
                data-aos-duration="1000"
              >
                <Typography gutterBottom variant="body2" sx={{
                   fontFamily: 'var(--fontFamily)',
                   color:'var(--textColor)'
                }}>
                  Unser Engagement für Qualität erstreckt sich auf alle unsere Dienstleistungen, einschließlich unserer hoch bewerteten Reinigungsdienste. Egal, ob Sie eine gründliche Bauabschlussreinigung für Ihr Wohnhaus, Ihr Bürogebäude oder Ihre gewerbliche Einrichtung benötigen, wir sind für Sie da. Unsere Bauabschlussreinigungsdienste zielen darauf ab, Ihre Baustelle in bestem Zustand zu übergeben, sei es nach Renovierungen, Neubauten oder Umbauten.
                <br />Wir verstehen die Bedeutung einer gründlichen und professionellen Bauabschlussreinigung, um sicherzustellen, dass Ihre Immobilie den höchsten Standards entspricht. Unser erfahrenes Reinigungsteam verwendet moderne Techniken und hochwertige Reinigungsmittel, um Baureste, Schmutz und Staub zu beseitigen. Wir kümmern uns um alle Bereiche Ihrer Baustelle, von Böden über Oberflächen bis hin zu Glasflächen.
                </Typography>
              </div>
            </div>
            <div className="textandphoto-service2">
              <div
                className="text-service-line2"
                data-aos="fade-right"
                data-aos-offset="300"
                data-aos-duration="1000"
              >
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: 'var(--fontFamily)',
                    color:'var(--textColor)'
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                 Professionelle Reinigung für alle Arten von Bauabschlussreinigung
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "var(--textColor)",
                    fontFamily: "var(--fontFamily)",
                  }}
                 
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                 Gründliche Entfernung von Schmutz, Staub und Rückständen
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "var(--textColor)",
                    fontFamily: "var(--fontFamily)",
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                Streifenfreie und glänzende Ergebnisse
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "var(--textColor)",
                    fontFamily: "var(--fontFamily)",
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                 Pünktliche und zuverlässige Dienstleistungen
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "var(--textColor)",
                    fontFamily: "var(--fontFamily)",
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                  Wettbewerbsfähige Preise und transparente Abrechnung
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "var(--textColor)",
                    fontFamily: "var(--fontFamily)",
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                  Hochbewertete Reinigung.
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "var(--textColor)",
                    fontFamily: "var(--fontFamily)",
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                  Wohnungsreinigungsdienst in der Nähe von Städten
                </Typography>
              </div>
              <div className="photo-service-line2">
                <div
                  className="photo3-service"
                  data-aos="flip-left"
                  data-aos-offset="200"
                  data-aos-duration="1000"
                >
                  <LazyLoadImage
                    src={imgServ4}
                    style={{
                      width: "100%",
                      borderRadius: "10px",
                      boxShadow: " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    }}
                  />
                </div>
                <div
                  className="photo4-service"
                  data-aos="flip-right"
                  data-aos-offset="200"
                  data-aos-duration="1000"
                >
                  <LazyLoadImage
                    src={imgServ3}
                    style={{
                      width: "100%",
                      borderRadius: "10px",
                      boxShadow: " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
    
          <Infokontakt />
          <Footer />
        </div>
      );
}

export default Constructioncleaning
